export const INITIALIZER_TYPE_ABSTRACT = 'Initializer';
export const INITIALIZER_TYPE_BODY = 'Body';
export const INITIALIZER_TYPE_BODY_SPRITE = 'BodySprite';
export const INITIALIZER_TYPE_TEXTURE = 'Texture';
export const INITIALIZER_TYPE_LIFE = 'Life';
export const INITIALIZER_TYPE_MASS = 'Mass';
export const INITIALIZER_TYPE_POSITION = 'Position';
export const INITIALIZER_TYPE_RADIUS = 'Radius';
export const INITIALIZER_TYPE_ZONE = 'Zone';
export const INITIALIZER_TYPE_VECTOR_VELOCITY = 'VectorVelocity';
export const INITIALIZER_TYPE_POLAR_VELOCITY = 'PolarVelocity';
export const INITIALIZER_TYPE_RADIAL_VELOCITY = 'RadialVelocity';
export const INITIALIZER_TYPE_RATE = 'Rate';
export const INITIALIZER_TYPES_THAT_REQUIRE_THREE = [
  INITIALIZER_TYPE_BODY_SPRITE,
  INITIALIZER_TYPE_TEXTURE,
];
